import React from "react";
import Grid from "@mui/material/Grid";

import ProfilePageCard from "./ProfilePageCard";

const Profile = (props) => {
  return (
    <Grid container>
      <Grid item xs={12} sx={{}}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-around",
            px: 3,
            py: 3,
          }}
        >
          <ProfilePageCard />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Profile;
